import * as React from 'react';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { CLASS_BOARD_DETAILS_SECTION } from '../../../../constants';
import { SettingsSection } from '../../../../../../base/components/SettingsSection/SettingsSection';
import './_MoveToSection.scss';
import { MoveToHOC } from '../../hocs/MoveToHOC/MoveToHOC';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';
import { TutorialHOC } from '../../../Tutorial/hocs/TutorialHOC/TutorialHOC';
import { BOARD_MOVE_TO_SECTION_TITLE } from './constants';
import { IMoveToSectionProps } from './types';

export function MoveToSection ({
}: IMoveToSectionProps) {
    const { boardId } = React.useContext(AsidePanelContext);
    const className = CLASS_BOARD_DETAILS_SECTION + ' ' + CLASS_BOARD_DETAILS_SECTION + '--move-to';

    return (
        <>
            <TutorialHOC boardSetting={EBoardSetting.MOVE_TO} />
            <SettingsSection
                className={className}
                title={BOARD_MOVE_TO_SECTION_TITLE}
            >
                <MoveToHOC
                    boardId={boardId}
                />
            </SettingsSection>
        </>
    );
};
